import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";
import { LimitsDto } from "@modules/+new/payments/shared-payments/dto/limits.dto";

export interface Limits {
	defaults: number[];
	readonly max: number;
	readonly min: number;
}

export class LimitsAdapter extends BaseAdapter<LimitsDto, Limits> {
	public adapt(item: LimitsDto): Limits {
		if (!item) {
			return null;
		}

		return {
			defaults: item.defaults?.map((defaultString) => Number(defaultString)),
			max: Number(item.max),
			min: Number(item.min)
		};
	}
}
